import { Link } from 'react-router-dom';
import { Banknote } from 'lucide-react';
import { Progress } from '@/design/components';
import { ModuleGate } from '@/access/Gate';
import { formatILS } from '@/lib/money';
import { targetPercent, trendLabel, useBranchSales } from './api';

/**
 * מכירות החודש בדשבורד ההנהלה (PRD 5.12.8).
 *
 * כרטיס נפרד ולא חלק מ RPC הדשבורד, כי מודול המכירות הוא תוספת:
 * רשת שלא רכשה אותו לא צריכה שהדשבורד שלה ישלם על השאילתה.
 */
export function DashboardSalesCard({ branchId }: { branchId: string | null }) {
  return (
    <ModuleGate module="sales" fallback={null}>
      <Inner branchId={branchId} />
    </ModuleGate>
  );
}

function Inner({ branchId }: { branchId: string | null }) {
  const sales = useBranchSales();
  const rows = (sales.data ?? []).filter((row) => !branchId || row.branch_id === branchId);

  if (rows.length === 0) return null;

  return (
    <Link to="/admin/sales" className="no-underline">
      <section className="grid h-full content-start gap-2 rounded-md border border-line bg-surface p-4">
        <div className="flex flex-wrap items-center gap-2">
          <Banknote size={20} strokeWidth={1.75} aria-hidden="true" />
          <h2 className="m-0 grow text-title font-semibold">מכירות החודש</h2>
        </div>

        <ul className="m-0 grid list-none gap-2 p-0">
          {rows.map((row) => (
            <li key={row.branch_id} className="grid gap-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="grow text-body-sm">{row.branch_name}</span>
                <span className="text-body-sm font-medium tabular">
                  {formatILS(row.this_month)}
                </span>
              </div>

              {row.target ? (
                <Progress
                  value={Math.min(row.this_month, row.target)}
                  max={row.target}
                  label={`${targetPercent(row.this_month, row.target)}% מהיעד`}
                />
              ) : (
                <span className="text-label text-muted">
                  {trendLabel(row.this_month, row.last_month) ?? 'בלי יעד לחודש'}
                </span>
              )}
            </li>
          ))}
        </ul>
      </section>
    </Link>
  );
}
